import React, { useState } from 'react';
import '../CSS/Logistics.css';

const Logistics: React.FC = () => {
  const [activeCollapsible, setActiveCollapsible] = useState(0);

  const handleCollapsibleClick = (index: number) => {
    setActiveCollapsible(index);
  };

  return (
    <div className="logistics-page">
      <div className="logistics_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Logistics</h1>
        </div>
      </div>

      <div className="logistics_description">
        <p>We develop and seamlessly integrate Al Agents into your existing tech infrastructure. Whether you are starting your Al journey or expanding existing capabilities, our expert team ensures a smooth and successful transition. Partner with us for real-time fleet management, refined workflows, streamlined internal communication & customer interactions, improved warehouse management, and more.</p>
      </div>

      {/* Logistics Collapsible Section - Desktop */}
      <div className="logistics_collapsible desktop-logistics-collapsible">
        <div className="logistics-collapsible-content">
          <div className="logistics-collapsible-column">
            {/* Left Column - First 5 items */}
            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 0 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(0)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Warehouse Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 0 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 0 && (
                <div className="logistics-collapsible-content">
                  <p>Empower your logistics business with our AI-powered warehouse management software, expertly designed for efficient stock control, smart labor and transport planning, and shipping management.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 1 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(1)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Transportation Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 1 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 1 && (
                <div className="logistics-collapsible-content">
                  <p>Our AI agents facilitate immediate data access, personalized reporting, and intelligent analytics support, enabling logistics companies to optimize, automate, and elevate their transportation operations.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 2 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(2)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Inventory Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 2 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 2 && (
                <div className="logistics-collapsible-content">
                  <p>Our advanced AI agents provide real-time insights into inventory levels, demand management, and automated reordering, ensuring that you always have the right products at the right time.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 3 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(3)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Fleet Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 3 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 3 && (
                <div className="logistics-collapsible-content">
                  <p>Optimize your fleet with our efficient AI Agents, providing real-time cargo tracking, efficient route planning, and enhanced resource management, all tailored to your operational needs.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 4 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(4)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Asset Tracking</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 4 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 4 && (
                <div className="logistics-collapsible-content">
                  <p>Our asset tracking solutions harness AI to offer real-time visibility and control over your valuable assets, improving tracking accuracy, reducing losses, and enhancing overall supply chain efficiency.</p>
                </div>
              )}
            </div>
          </div>

          <div className="logistics-collapsible-column">
            {/* Right Column - Last 5 items */}
            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 5 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(5)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Order Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 5 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 5 && (
                <div className="logistics-collapsible-content">
                  <p>Streamline order processes with our Order Management AI Agent, ensuring swift fulfillment, accurate shipping, and real-time inventory tracking while handling on-demand requests and fleet allocation.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 6 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(6)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Demand Management</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 6 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 6 && (
                <div className="logistics-collapsible-content">
                  <p>We develop robust AI Agents that allow users to plan their monthly orders, understand seasonal trends, save time on re-ordering, and reduce stock-outs.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 7 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(7)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Route Optimization</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 7 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 7 && (
                <div className="logistics-collapsible-content">
                  <p>Leveraging historical trip sheets and real-time figures to calculate the delivery time for each shipment, our AI-enabled software can optimize the routes for every delivery vehicle in real time.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 8 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(8)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Customer Experience</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 8 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 8 && (
                <div className="logistics-collapsible-content">
                  <p>Ensure superior customer journeys with our AI-enhanced CX solutions that ensure seamless interactions, automated billing, data-driven insights and more across all touchpoints.</p>
                </div>
              )}
            </div>

            <div 
              className={`logistics-collapsible-item ${activeCollapsible === 9 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(9)}
            >
              <div className="logistics-collapsible-header">
                <h3 className="logistics-collapsible-title">Analytics & Business Intelligence (BI)</h3>
                <div className="logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 9 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 9 && (
                <div className="logistics-collapsible-content">
                  <p>Our advanced analytics and Business Intelligence (BI) software provide deep insights into your operations, enabling data-driven decision-making, cost optimization, and enhanced performance.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Logistics Collapsible Section - Mobile (480px) */}
      <div className="logistics_collapsible mobile-logistics-collapsible">
        <div className="logistics-collapsible-content">
          <div className="mobile-logistics-collapsible-column">
            {/* All items in single vertical column for mobile */}
            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 0 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(0)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Warehouse Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 0 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 0 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Empower your logistics business with our AI-powered warehouse management software, expertly designed for efficient stock control, smart labor and transport planning, and shipping management.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 1 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(1)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Transportation Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 1 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 1 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Our AI agents facilitate immediate data access, personalized reporting, and intelligent analytics support, enabling logistics companies to optimize, automate, and elevate their transportation operations.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 2 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(2)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Inventory Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 2 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 2 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Our advanced AI agents provide real-time insights into inventory levels, demand management, and automated reordering, ensuring that you always have the right products at the right time.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 3 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(3)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Fleet Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 3 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 3 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Optimize your fleet with our efficient AI Agents, providing real-time cargo tracking, efficient route planning, and enhanced resource management, all tailored to your operational needs.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 4 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(4)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Asset Tracking</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 4 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 4 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Our asset tracking solutions harness AI to offer real-time visibility and control over your valuable assets, improving tracking accuracy, reducing losses, and enhancing overall supply chain efficiency.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 5 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(5)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Order Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 5 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 5 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Streamline order processes with our Order Management AI Agent, ensuring swift fulfillment, accurate shipping, and real-time inventory tracking while handling on-demand requests and fleet allocation.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 6 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(6)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Demand Management</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 6 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 6 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>We develop robust AI Agents that allow users to plan their monthly orders, understand seasonal trends, save time on re-ordering, and reduce stock-outs.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 7 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(7)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Route Optimization</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 7 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 7 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Leveraging historical trip sheets and real-time figures to calculate the delivery time for each shipment, our AI-enabled software can optimize the routes for every delivery vehicle in real time.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 8 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(8)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Customer Experience</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 8 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 8 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Ensure superior customer journeys with our AI-enhanced CX solutions that ensure seamless interactions, automated billing, data-driven insights and more across all touchpoints.</p>
                </div>
              )}
            </div>

            <div 
              className={`mobile-logistics-collapsible-item ${activeCollapsible === 9 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(9)}
            >
              <div className="mobile-logistics-collapsible-header">
                <h3 className="mobile-logistics-collapsible-title">Analytics & Business Intelligence (BI)</h3>
                <div className="mobile-logistics-collapsible-arrow">
                  <img 
                    src={activeCollapsible === 9 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 9 && (
                <div className="mobile-logistics-collapsible-content">
                  <p>Our advanced analytics and Business Intelligence (BI) software provide deep insights into your operations, enabling data-driven decision-making, cost optimization, and enhanced performance.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Logistics Why Choose Section - Desktop */}
      <div className="logistics_why_choose desktop-logistics-why-choose">
        <div className="why-choose-content">
          <h2 className="why-choose-title">Why choose Zemantics?</h2>
          <div className="why-choose-cards">
            <div className="why-choose-card">
              <div className="card-icon">
                <img src="/Assets/Icons/agile-development-icon.svg" alt="Agile Development" />
              </div>
              <h3 className="card-title">Agile Development</h3>
              <p className="card-description">We employ an agile methodology to craft AI-powered logistics software solutions that are robust, flexible, and scalable, with a primary focus on delivering value to end-users while minimizing risks.</p>
            </div>

            <div className="why-choose-card">
              <div className="card-icon">
                <img src="/Assets/Icons/quality-assurance-icon.svg" alt="Quality Assurance" />
              </div>
              <h3 className="card-title">Quality Assurance</h3>
              <p className="card-description">We test every aspect of the software, from functionality to security, ensuring it functions flawlessly and efficiently, giving you peace of mind and confidence in the reliability of your logistics operations.</p>
            </div>

            <div className="why-choose-card">
              <div className="card-icon">
                <img src="/Assets/Icons/data-security-icon.svg" alt="Data Security and Protection" />
              </div>
              <h3 className="card-title">Data Security and Protection</h3>
              <p className="card-description">We guarantee the highest level of security when handling client data and safeguard the AI software we create with encryption, access controls, vulnerability assessments, and ongoing updates.</p>
            </div>

            <div className="why-choose-card">
              <div className="card-icon">
                <img src="/Assets/Icons/24-7-support-icon.svg" alt="24/7 Support" />
              </div>
              <h3 className="card-title">24/7 Support</h3>
              <p className="card-description">Whether it's troubleshooting unexpected issues, fine-tuning configurations, or providing timely assistance, we are here to keep your logistics processes optimized and efficient, no matter the hour.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Logistics Why Choose Section - Mobile (480px) */}
      <div className="logistics_why_choose mobile-logistics-why-choose">
        <div className="mobile-why-choose-content">
          <h2 className="mobile-why-choose-title">Why choose Zemantics?</h2>
          <div className="mobile-why-choose-cards">
            <div className="mobile-why-choose-card">
              <div className="mobile-card-icon">
                <img src="/Assets/Icons/agile-development-icon.svg" alt="Agile Development" />
              </div>
              <h3 className="mobile-card-title">Agile Development</h3>
              <p className="mobile-card-description">We employ an agile methodology to craft AI-powered logistics software solutions that are robust, flexible, and scalable, with a primary focus on delivering value to end-users while minimizing risks.</p>
            </div>

            <div className="mobile-why-choose-card">
              <div className="mobile-card-icon">
                <img src="/Assets/Icons/quality-assurance-icon.svg" alt="Quality Assurance" />
              </div>
              <h3 className="mobile-card-title">Quality Assurance</h3>
              <p className="mobile-card-description">We test every aspect of the software, from functionality to security, ensuring it functions flawlessly and efficiently, giving you peace of mind and confidence in the reliability of your logistics operations.</p>
            </div>

            <div className="mobile-why-choose-card">
              <div className="mobile-card-icon">
                <img src="/Assets/Icons/data-security-icon.svg" alt="Data Security and Protection" />
              </div>
              <h3 className="mobile-card-title">Data Security and Protection</h3>
              <p className="mobile-card-description">We guarantee the highest level of security when handling client data and safeguard the AI software we create with encryption, access controls, vulnerability assessments, and ongoing updates.</p>
            </div>

            <div className="mobile-why-choose-card">
              <div className="mobile-card-icon">
                <img src="/Assets/Icons/24-7-support-icon.svg" alt="24/7 Support" />
              </div>
              <h3 className="mobile-card-title">24/7 Support</h3>
              <p className="mobile-card-description">Whether it's troubleshooting unexpected issues, fine-tuning configurations, or providing timely assistance, we are here to keep your logistics processes optimized and efficient, no matter the hour.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logistics; 